import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { AddOnsData } from "../setup/setupResponse";

interface GuestState {
    availableCategories: string[]
    selectedCategories: string[]
    availableSize: string[]
    selectedSize: string[]
    addQty: number;
    selectItemLoading: number | null
    selectedAddons: AddOnsData[] | null,

    selectProductDetails: {
        packageID: number | null;
        productID: number | null;
        sizeID: number | null;
        cartItemID: number | null;
        type: null | 'new' | 'update'
    }
}

const initialState: GuestState = {
    availableCategories: ['All'],
    selectedCategories: ['All'],
    availableSize: ['All'],
    selectedSize: ['All'],
    addQty: 1,
    selectItemLoading: null,
    selectedAddons: null,
    selectProductDetails: {
        packageID: null,
        productID: null,
        sizeID: null,
        cartItemID: null,
        type: null
    }

};

const guestSlice = createSlice({
    name: "guest",
    initialState,
    reducers: {
        selectProductDetails :(state, action: PayloadAction<{ packageID: number | null; productID: number | null; sizeID: number | null; type: null | 'new' | 'update'; cartItemID: number | null }>) => {
            state.selectProductDetails = action.payload;
        },
        setSelectedAddons: (state, action: PayloadAction<AddOnsData>) => {
            if (!state.selectedAddons) {
                state.selectedAddons = [action.payload];
                return;
            }

            const exists = state.selectedAddons.some(
                addon => addon.addonID === action.payload.addonID
            );

            if (exists) {
                state.selectedAddons = state.selectedAddons.filter(
                    addon => addon.addonID !== action.payload.addonID
                );
            } else {
                state.selectedAddons.push(action.payload);
            }
        },
        setSelectedAddonsArray: (state, action: PayloadAction<AddOnsData[] | null>) => {
            state.selectedAddons = action.payload;
        },
        setClearAddons: (state) => {
            state.selectedAddons = null;
        },
        setSelectedItemLoading: (state, action: PayloadAction<number | null>) => {
            state.selectItemLoading = action.payload;
        },
        clearSelectedItemLoading: (state) => {
            state.selectItemLoading = null;
        },
        // CATEGORY
        setSelectSingleCategory: (state, action: PayloadAction<string>) => {
            state.selectedCategories = [action.payload];
        },
        setSelectCategory: (state, action: PayloadAction<string>) => {
            if (!state.selectedCategories.includes(action.payload)) {
                state.selectedCategories.unshift(action.payload);
            }
        },

        removeCategory: (state, action: PayloadAction<string>) => {
            state.selectedCategories = state.selectedCategories.filter(
                (cat) => cat !== action.payload
            );
        },

        setAvailableCategories: (state, action: PayloadAction<string[]>) => {
            state.availableCategories = action.payload;
        },

        // SIZE
        setSelectSingleSize: (state, action: PayloadAction<string>) => {
            state.selectedSize = [action.payload];
        },
        setSelectSize: (state, action: PayloadAction<string>) => {
            if (!state.selectedSize.includes(action.payload)) {
                state.selectedSize.unshift(action.payload);
            }
        },

        removeSize: (state, action: PayloadAction<string>) => {
            state.selectedSize = state.selectedSize.filter(
                (size) => size !== action.payload
            );
        },

        setAvailableSize: (state, action: PayloadAction<string[]>) => {
            state.availableSize = action.payload;
        },

        clearSelections: (state) => {
            state.selectedCategories = [];
            state.selectedSize = [];
        },

        setAddQty: (state, action: PayloadAction<number>) => {
            state.addQty = action.payload;
        },
        clearAddQty: (state) => {
            state.addQty = 1;
        },
        
    },
});

export const {
    selectProductDetails,

    setSelectSingleCategory,
    setSelectCategory,
    removeCategory,
    setAvailableCategories,

    setSelectSingleSize,
    setSelectSize,
    removeSize,
    setAvailableSize,
    clearSelections,
    setAddQty,
    clearAddQty,

    setSelectedAddons,
    setSelectedAddonsArray,
    setClearAddons,

    setSelectedItemLoading,
    clearSelectedItemLoading
} = guestSlice.actions;

export default guestSlice.reducer;

export const selectAvailableCategories = (state: RootState) => state.guest.availableCategories;
export const selectCategories = (state: RootState) => state.guest.selectedCategories
export const selectAvailableSize = (state: RootState) => state.guest.availableSize
export const selectSize = (state: RootState) => state.guest.selectedSize

export const selectSelectedAddonsProduct = (state: RootState) => state.guest.selectedAddons;

export const selectQuantity = (state: RootState) => state.guest.addQty

export const selectItemLoading = (state: RootState) => state.guest.selectItemLoading

export const selectSelectedProductDetails = (state: RootState) => state.guest.selectProductDetails;